//import { observer } from "mobx-react";
import { MSAView } from "react-msaview";
import { createJBrowseTheme } from "@jbrowse/core/ui/theme";
import { ThemeProvider } from "@material-ui/core/styles";
import AppGlobal from "./model";
import {saveAs} from 'file-saver';
import {
	Card, Button, ButtonGroup
} from "react-bootstrap";
import {
  BlobWriter,
  TextReader,
  ZipWriter,
} from "@zip.js/zip.js";

function stamp(region){
  return `${region.chr}_${region.start}_${region.end}`;
}

async function downloadConsensus(fastas, region){
  //console.log(fastas);
  const blob = new Blob([fastas.consensus.replace("ㅤ", " ")], {type: "text/plain;charset=utf-8"});
  saveAs(blob, `consensus_${stamp(region)}.fa`);
  console.log("Downloaded Consensus");
}

async function downloadFastas(fastas, region){
  // Creates a BlobWriter object where the zip content will be written.
  const zipFileWriter = new BlobWriter();
  
  const zipWriter = new ZipWriter(zipFileWriter);

  await Promise.all(Object.keys(fastas).map(async (key) => {
    // Creates a TextReader object storing the text of the entry to add in the zip
    const reader = new TextReader(fastas[key].replace("ㅤ", " "));
    await zipWriter.add(`${key}.fa`, reader);
  }));

  const blob = await zipWriter.close();
  saveAs(blob, `sequences__${stamp(region)}.zip`);
  console.log("Downloaded");
}
function SequenceView({fastas, form, annotations}) {
  //console.log(form);
  const panelEnabled = fastas && !(Object.keys(fastas).length === 0 && Object.getPrototypeOf(fastas) === Object.prototype)
  const viewEnabled = form && form.region && (form.region.end-form.region.start) < form.regionViewLimit;

  const fastaString = panelEnabled && viewEnabled ? fastas.all : "";
  // Create blob url for the fasta file string
  const fastaBlob = new Blob([fastaString], {type: "text/plain;charset=utf-8"});
  const fastaUrl = URL.createObjectURL(fastaBlob);
  console.log(fastaUrl);
  const mymodel = AppGlobal.create( { msaview: { type: "MsaView", data:{ msa:  fastaString}, labelsAlignRight: true, treeAreaWidth:200 } }
  );
  // Add annotations to the model  
  if (viewEnabled && panelEnabled && annotations && Object.keys(annotations).length > 0){
    // Filter to the ones in the region
    //console.log(Object.keys(annotations))
    const namedSNPs = Object.keys(annotations).filter((pos) => {
      const formPos = parseInt(pos);
      return formPos >= form.region.start && formPos <= form.region.end;
    });
    console.log(`${namedSNPs.length} annotations found in region: ${namedSNPs}`);
    for(const pos of namedSNPs){
      var relativePos = pos - form.region.start + 1;
      //Get nearest lower offset
      var offset = 0;
      if(form.offsets !== undefined){
        offset = form.offsets[Object.keys(form.offsets).filter((offset) => offset < relativePos).pop()];
        if(offset === undefined){
          offset = 0;
        }
      }
      mymodel.msaview.addAnnotation(relativePos + offset, relativePos + offset, {"Name": [annotations[pos]], "Position": [pos]});
    }
  }
  // Set color scheme
  mymodel.msaview.setColorSchemeName("flower")
  mymodel.msaview.setWidth(window.innerWidth);
  console.log(mymodel.msaview.turnedOnTracks)
  // Handle window resizing
  window.addEventListener("resize", () => {
    mymodel.msaview.setWidth(window.innerWidth);
  });
  const theme = createJBrowseTheme();

  //console.log(theme);
  return (
    <div id="sequenceview">
      {  
        panelEnabled && 
        <div id="sequencecontainer">
          <Card id="sequencecard" className="m-2 shadow card text-bg-dark mb-3">
            <Card.Header className="display-6 d-flex mt-2 mx-2 justify-content-between align-items-center ">
              <div>
                Sequence View
                <p className="lead">Chromosome {form.region.chr}: {form.region.start} - {form.region.end} </p>
              </div>
                <ButtonGroup>
                  <Button variant="primary" size='md' onClick={() => downloadConsensus(fastas, form.region)}>
                      Download Consensus <i className="bi-download"></i>
                    </Button>
                  <Button variant="secondary" size='md' onClick={() => downloadFastas(fastas, form.region)}>
                    Download all Sequences <i className="bi-download"></i>
                  </Button>
                </ButtonGroup>
            </Card.Header>

            {viewEnabled ? <Card className="m-4 card text-bg-light">
              <MSAView model={mymodel.msaview} />
            </Card>: <div>View disabled <br/>Regions bigger than {form.regionViewLimit/1000}Mb will disable the view</div>}
          </Card>
      </div>
      }
    </div>
  );
};

export default SequenceView;
